// DialogEmailResend Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import InputTag from '../../../common/form/input_tag/input_tag.jsx'
import Select from '../../../common/form/select/select.jsx'
import Util from '../../../lib/util.jsx'

class DialogEmailResend extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      showError: false,
      dataDate: null,
      bTagFocus: false,
      bEmailErr: false
    }

    this.data = {
      mail: [],
      invoiceId: null,
      invoice: [],
      languages: [
        { label: 'user.signup.optionNederlands', value: 'nl' },
        { label: 'user.signup.optionEnglish', value: 'en' },
        { label: 'user.signup.optionDeutsch', value: 'de' }
      ]
    }
    this._references = {
      inputTagMail: React.createRef(),
      inputSubject: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      onDownload: PropTypes.func,
      downloadBaseUrl: PropTypes.string,
      showWithoutContext: PropTypes.bool,
      showLanguage: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      onDownload: null,
      downloadBaseUrl: '',
      showWithoutContext: false,
      showLanguage: false
    }
  }

  show (mailObj, invoiceId, invoice) {
    FabButtonManager.setVisible(false)
    if (mailObj) {
      const { subject, content } = this._getMailDataFromLanguage(
        mailObj,
        mailObj.language
      )
      mailObj.subject = subject
      mailObj.content = content

      this.data.mail = mailObj
    }

    this.data.invoice = invoice
    this.data.invoiceId = invoiceId
    this.setState({ active: true, dataDate: new Date() })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      showError: false,
      dataDate: null,
      bEmailErr: false,
      bTagFocus: false
    })

    this.data.mail.toEmails = []
  }

  isActive () {
    return this.state.active
  }

  _onClickTag () {
    if (this._references.inputTagMail.current) {
      this._references.inputTagMail.current.focus()
    }

    this.setState({ bTagFocus: true })
  }

  _onFocusInput () {
    this.setState({ bTagFocus: false })
  }

  _onUpdateToMails (toEmails) {
    this.data.mail.toEmails = toEmails
    this.setState({ bEmailErr: false, dataDate: new Date() })
  }

  render () {
    const { showLanguage } = this.props
    const { invoice } = this.data
    const mail = this.data.mail

    if (!mail) {
      return null
    }

    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'
    const invoiceId = this.data.invoiceId
    const xmlUrl = encodeURI(
      `/invoice/xml/preview/${mail.teamId}/${mail.xmlAttachment}/`
    )

    const tagClassName = `formcol formcol_tag${
      this.state.bTagFocus ? ' active' : ''
    }`
    const toTagBtmCls = this.state.bEmailErr
      ? 'tagbottom haserror'
      : 'tagbottom'
    const invoiceStatus = invoice.status ? invoice.status : ''
    let pdfFileName = ''
    if (invoice) {
      pdfFileName = Util.getPdfFileName(
        'invoice',
        invoice.invoiceNo,
        invoiceStatus
      )
    }
    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        type='medium'
      >
        <div className='dialog-form estimatemail-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='common.form.emailResendDialogTitle' />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='estimate.form.emailDialogErrorInfo' />
              </div>
            )}
            <div className='action'>
              <IconButton
                icon='common-send'
                className='send-button'
                size='big'
                tooltip='common.list.tipSend'
                tooltipPosition='top'
                canHover
                onClick={this._onFormSubmit.bind(this)}
              />
            </div>
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div
                        className={tagClassName}
                        onClick={this._onClickTag.bind(this)}
                      >
                        <InputTag
                          placeholder='estimate.form.labelTo'
                          ref={this._references.inputTagMail}
                          tags={mail.toEmails}
                          bAlt
                          tagSuggestions={mail.emailSuggestions}
                          onUpdateTags={this._onUpdateToMails.bind(this)}
                          delimiterKeys={[32, 9, 13]}
                          showOptionIcon
                          withoutContext={this.props.showWithoutContext}
                        />
                        <span className={toTagBtmCls} />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='subject'
                          value={mail.subject}
                          label='estimate.form.labelSubject'
                          size={10}
                          maxLength={100}
                          ref={this._references.inputSubject}
                          validations={['required']}
                          onFocus={this._onFocusInput.bind(this)}
                          onChange={this._onChangeInput.bind(this, 'subject')}
                        />
                      </div>
                    </div>
                    {showLanguage && this._renderLanguageOptions()}
                    <div className='formrow'>
                      <div className='formcol'>
                        <div className='attachment'>
                          {this.props.downloadBaseUrl ? (
                            <a
                              href={encodeURI(
                                `${this.props.downloadBaseUrl}${invoiceId}/false/${pdfFileName}`
                              )}
                              className='label'
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              {mail.attachment}
                            </a>
                          ) : (
                            <span
                              className='label'
                              onClick={this._onClickAttachment.bind(this)}
                            >
                              {mail.attachment}
                            </span>
                          )}
                          {mail.xmlAttachment && (
                            <a href={xmlUrl} className='label' target='_blank' rel='noopener noreferrer'>
                              {mail.xmlAttachment}
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <WysiwygEditor
                          placeholder='estimate.form.labelMessage'
                          value={mail.content}
                          onBlur={this._onChangeInput.bind(this, 'content')}
                          isUpdatable
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (ev) {
    ev.preventDefault()
    let noErrors = 0
    let bEmailErr = false

    if (
      this._references.inputTagMail.current &&
      this.data.mail.toEmails.length === 0
    ) {
      noErrors++
      bEmailErr = true
    }

    if (
      this._references.inputSubject.current &&
      !this._references.inputSubject.current.validate()
    ) {
      noErrors++
    }

    if (noErrors === 0) {
      if (this.props.onSubmit) {
        this.props.onSubmit(this.data.mail)
      }
    } else {
      this.setState({ showError: true, bEmailErr: bEmailErr })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onClickAttachment (ev) {
    ev.preventDefault()

    if (this.props.onDownload) {
      this.props.onDownload(this.data.mail.id)
    }
  }

  _onChangeInput (name, value) {
    this.data.mail[name] = value
    this.setState({ dataDate: new Date() })
  }

  _onChangeEmailLanguage (value) {
    const { mail } = this.data
    const { subject, content } = this._getMailDataFromLanguage(mail, value)

    mail.language = value
    mail.subject = subject
    mail.content = content

    this.setState({ dataDate: new Date() })
  }

  _getMailDataFromLanguage (mail, language) {
    let subject = ''
    let content = ''
    const langData = mail.allLanguageData
      ? mail.allLanguageData[(language || 'en').toLowerCase()]
      : null
    if (langData) {
      subject = langData.subject
      content = langData.content
    }

    return { subject, content }
  }

  _renderLanguageOptions () {
    return (
      <div className='formrow'>
        <div className='formcol'>
          <Select
            options={this.data.languages}
            label='estimate.form.labelLanguage'
            className='form-dropdown'
            value={this.data.mail.language}
            styleDotted
            multilingualOptions
            name='country'
            onChange={this._onChangeEmailLanguage.bind(this)}
          />
        </div>
      </div>
    )
  }
}

export default DialogEmailResend
